export default {"src":"/_next/static/media/EHACare.12982944.svg","height":647,"width":992};